import { Injectable } from '@angular/core';
import { Entity, Enum } from '@app/app.model';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment as e } from 'src/environments/environment';
import { Factor, FactorInterface } from './factor.model';
import { ErrorsService } from '@app/_shared/errors/errors.service';

@Injectable({
  providedIn: 'root'
})
export class FactorService implements FactorInterface {

  constructor(private _http: HttpClient, private errors$: ErrorsService) { }

  private listRetrieved: BehaviorSubject<Factor[]> = new BehaviorSubject<Factor[]>(undefined);
  ListRetrieved = this.listRetrieved.asObservable();
  notifyRetrieved(data: Factor[]): void {
    this.listRetrieved.next(data);
  }

  save: (data: Entity<Factor>) => Observable<any>;

  create(data: Entity<Factor>): Observable<any> {
    return this._http.put<Factor>(e.endpoint.products.factor,
      data.value).pipe(catchError(this.errors$.handleNetworkError));
  }
  delete(param: any): Observable<any> {
    return this._http.delete(e.endpoint.products.factor + "/" + param.Id + "/" + param.Code, {
      responseType: "text"
    },).pipe(catchError(this.errors$.handleNetworkError));
  }
  getEntity(param: any): Observable<Factor> {
    return this._http.get<Factor>(e.endpoint.products.factor + "/" + param.Id + "/" + param.Code)
    .pipe(catchError(this.errors$.handleNetworkError));
  }
  getList(lookup: any): Observable<Factor[]> {
    return this._http.get<Factor[]>(e.endpoint.products.factor)
    .pipe(catchError(this.errors$.handleNetworkError));
  }

  getNewEntity(): Observable<Factor> {
    return this._http.get<Factor>(e.endpoint.products.factor + '/newfactor')
    .pipe(catchError(this.errors$.handleNetworkError));
  }

  getQuantityUnitList(): Observable<Enum[]> {
    return this._http.get<Enum[]>(e.endpoint.products.quantityUnit)
    .pipe(catchError(this.errors$.handleNetworkError));
  }
}
